import React, { useEffect } from 'react';
import { Box, Button, Container, Paper, TextField } from '@mui/material';
import { Check } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';

import { Subheader } from 'components';
import LotteryDrawForm from 'features/lotteryDraws/LotteryDrawForm';
import { useAlerts, useLotteryDraws } from 'hooks';
import { validateLotteryDraw } from 'validations/lotteryDraws';

const LotteryDrawEdit = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { lotteryDraw, handleChange, updateLotteryDraw, findLotteryDraw } =
		useLotteryDraws({ id: id });

	const { showAlertSuccess, showAlertError } = useAlerts();

	const handleSaveClick = async () => {
		const valid = validateLotteryDraw(lotteryDraw);
		if (valid.isValid) {
			await updateLotteryDraw(lotteryDraw);
			showAlertSuccess('Lottery Draw has been updated');
			navigate(`/lottery_draws/${id}`);
		} else {
			valid.messages.map((m) => showAlertError(m));
		}
	};

	useEffect(() => {
		if (id) findLotteryDraw(id);
	}, []);

	return (
		<>
			<Subheader
				title="Edit Lottery Draw"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<LotteryDrawForm
							lotteryDraw={lotteryDraw}
							handleChange={handleChange}
						/>
						<Box py={2}>
							<Button
								color="primary"
								variant="contained"
								startIcon={<Check />}
								onClick={handleSaveClick}
							>
								Save
							</Button>
						</Box>
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default LotteryDrawEdit;
